import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPersonBlue = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Capa_1",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 800 800",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: "\n      .person-fill {\n        fill: #002ff4;\n      }\n    " }) }),
		/* @__PURE__ */ _jsx("path", {
			className: "person-fill",
			d: "M745.22,782.98H54.63s-.03-62.52-.03-62.52c.99-122.23,100.85-230.71,223.68-237.03,67.41-3.47,140.31-1.57,207.94.08,17.99.44,34.31-.35,52.36,2,100.62,13.1,182.87,90.19,202.38,189.65,7,35.68,3.44,71.64,4.26,107.82ZM98.99,741.01h601.87c1.36-.84,1.32-1.9,1.48-3.29,4.15-35.4-9.05-84.84-26.59-115.63-30.61-53.72-92.22-91.77-154.22-95.69-79.22-5.01-163.52,3.77-243.27-.06-80.96,6.65-148.74,62.28-172.37,139.53-5.94,19.42-10.73,51.79-8.38,71.84.16,1.39.12,2.45,1.48,3.29Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "person-fill",
			d: "M545.47,77.56c129.01,123.55,60.41,342.34-115.76,369.41-162.62,24.99-296.2-130.96-239.64-287.34C243.26,12.51,432.11-31.01,545.47,77.56ZM377.79,60.26c-137.47,11.53-204.69,172.12-119.97,280.59,84.28,107.9,262.04,78.93,303.02-52.71,37.76-121.3-57.07-238.45-183.05-227.88Z"
		})
	]
});
export default SvgPersonBlue;
